import { ApiProperty } from '@nestjs/swagger';
import { IsBoolean } from 'class-validator';

/**
 * Indicates whether feedback already exists for a given deal.
 */
export class DealFeedbackExistedResponse {
  @ApiProperty({
    description: 'True if feedback has already been submitted for this deal',
    example: true,
  })
  @IsBoolean()
  feedbackExisted: boolean;
}
